//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    MESSAGE_TEMPLATE_CREATE_REQUEST,
    MESSAGE_TEMPLATE_EDIT_REQUEST,
    MESSAGE_TEMPLATE_GET_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    messageTemplateCreateResult,
    messageTemplateEditResult,
    messageTemplateGetResult,
    
} from 'Redux/actions';

function* getMessageTemplate({ payload }) {
    try {
        let QUERY = `
            query getMessageTemplate ($id: Int!) {
                result: getMessageTemplate (id: $id) {
                    templateCode
                    language
                    emailFrom
                    emailSubject
                    emailBody
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(messageTemplateGetResult(data.result))

    } catch (exc) {
        yield put(messageTemplateGetResult())
        ExceptionManager(exc, 'Modules/brands/views/.components/createEditMessageTemplate/redux/saga', 'getMessageTemplate');
    }
}

function* createMessageTemplate({ payload }) {
    try {
        let QUERY = `
            mutation createMessageTemplate ($templateCode: String!, $language: String!, $entityNameId: String!, $emailFrom: String!, $emailSubject: String!, $emailBody: String!) {
                result: createMessageTemplate (templateCode: $templateCode, language: $language, entityNameId: $entityNameId,  emailFrom: $emailFrom, emailSubject: $emailSubject, emailBody: $emailBody) {
                    id
                    templateCode
                    language
                    emailFrom
                    emailSubject
                    emailBody
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(messageTemplateCreateResult(data?.result))
        } else yield put(messageTemplateCreateResult())

    } catch (exc) {
        yield put(messageTemplateCreateResult({ error: exc.error }))
        //ExceptionManager(exc, 'Modules/brands/views/.components/createEditMessageTemplate/redux/saga', 'createMessageTemplate', true);
    }
}

function* updateMessageTemplate({ payload }) {
    try {
        let QUERY = `
            mutation updateMessageTemplate ($id: Int!, $emailFrom: String!, $emailSubject: String!, $emailBody: String!) {
                result: updateMessageTemplate (id: $id, emailFrom: $emailFrom, emailSubject: $emailSubject, emailBody: $emailBody) {
                    id
                    templateCode
                    language
                    emailFrom
                    emailSubject
                    emailBody
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(messageTemplateEditResult(data?.result));

    } catch (exc) {
        yield put(messageTemplateEditResult())
        ExceptionManager(exc, 'Modules/brands/views/.components/createEditMessageTemplate/redux/saga', 'updateMessageTemplate');
    }
}

function* watchMessageTemplateRequests() {
    yield takeEvery(MESSAGE_TEMPLATE_GET_REQUEST, getMessageTemplate);
    yield takeEvery(MESSAGE_TEMPLATE_CREATE_REQUEST, createMessageTemplate);
    yield takeEvery(MESSAGE_TEMPLATE_EDIT_REQUEST, updateMessageTemplate);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchMessageTemplateRequests)
    ]);
}